import { useMemo } from 'react';
import { initializeReactMetadata } from '@Services/ResultsDataManage/initializeReactMetadata';

export default function useResultsMetadata(params) {
  return useMemo(() => {
    return initializeReactMetadata(params);
  }, [params]);
}
